import {get} from "lodash"
import BaseService from "./Base"
import {CallLogStats, StudentCallLog} from "types/student-call-log"
import {StudentVoiceMail} from "types/student-voice-mail"

class StudentCallLogService extends BaseService {
    async list(params): Promise<{total: number; data: StudentCallLog[]}> {
        const response = await this.post("/v1/student-call-logs/list", params)
        return get(response, "data", [])
    }

    async stat(params): Promise<CallLogStats> {
        const response = await this.post("/v1/student-call-logs/stats", params)
        return get(response, "data.data", {})
    }

    async add(params): Promise<StudentCallLog> {
        const response = await this.post("/v1/student-call-logs/add", params)
        return get(response, "data.data", {})
    }

    async markVoiceMailAsRead(params): Promise<void> {
        const response = await this.post("/v1/student-voice-mails/mark-as-read", params)
        return get(response, "data.data", {})
    }

    async listVoiceMail(params): Promise<{total: number; data: StudentVoiceMail[]}> {
        const response = await this.post("/v1/student-voice-mails/list", params)
        return get(response, "data", [])
    }

    async getVoiceMailUnreadCount(params): Promise<{unreadCount: number}> {
        const response = await this.post("/v1/student-voice-mails/unread-count", params)
        return get(response, "data.data", {})
    }

    async forwardCall(params: {browserCallId: string; staffProfileId: number}): Promise<void> {
        const response = await this.post("/v1/twilio/forward", params)
        return get(response, "data.data", {})
    }

    async forwardTelnyxCall(params: {browserCallId: string; staffProfileId: number}): Promise<void> {
        const response = await this.post("/v1/telnyx/forward", params)
        return get(response, "data.data", {})
    }
}

export default StudentCallLogService
